export default "__VITE_ASSET__Dx2I2pND__"